export const LOAN_EARNINGS_STATUSES = {
  accrued: 'accrued',
  scheduled: 'scheduled',
};
